import { Explain } from './Explain';

export function PrivacyBanner() {
  return (
    <div className="privacy" role="note" aria-label="Privacy statement">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 2.5l7 3v5.5c0 4.4-3 8.2-7 9.5-4-1.3-7-5.1-7-9.5V5.5l7-3z"
          stroke="var(--accent)"
          strokeWidth="1.5"
          fill="var(--accent-soft)"
          strokeLinejoin="round"
        />
        <path d="M8.8 12.2l2.2 2.2 4.2-4.6" stroke="var(--accent)" strokeWidth="1.6"
          strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div>
        <div className="headline">Private by design — your genome never leaves this device.</div>
        <div className="detail">
          Files are parsed in-memory, in your browser. No uploads, no servers, no analytics.
          Outbound connections are blocked at the page level.{' '}
          <Explain id="reidentification" variant="link" label="Read this">
            But your genome still identifies you — here’s why.
          </Explain>
        </div>
      </div>
      <span className="pill">100% local</span>
      <Explain id="privacy" label="How does this work?" />
    </div>
  );
}
